import React from 'react';

const AuthorizeInformationAccessText: React.FC = (): JSX.Element => (
    <div className="l-article">
        <p>
            Por meio da presente, autorizo a BizCapital Sociedade de Crédito Direto S.A., inscrita no CNPJ sob o nº 45.597.546/0001-00
            (“BizCapital SCD”), a BMP Money Plus Sociedade de Crédito Direto S.A., inscrita no CNPJ sob o nº 34.337.707/0001-00 (“BMP”)
            e a Qi Sociedade de Crédito Direto S.A., inscrita no CNPJ sob o nº 32.402.502/0001-35 ("Qi Tech”, juntamente com a
            BizCapital SCD e a BMP, “Instituições Financeiras” e, individualmente, “Instituição Financeira”), na qualidade de instituição financeira
            concedente do crédito por mim solicitado, a consultar as informações, os débitos e as responsabilidades decorrentes de operações de crédito,
            bem como os registros de medidas judiciais que em meu nome e em nome das sociedades nas quais detenho participação acionária e/ou
            atuo como representante legal (“Minhas Informações”), constem ou venham a constar do Sistema de Informações de Crédito (“SCR”),
            gerido pelo Banco Central do Brasil (“BCB”), ou dos sistemas que venham a complementá-lo ou a substituí-lo.
        </p>
        <p>
            Outrossim, nos termos do artigo 1º, parágrafo 3º, inciso V, da Lei Complementar nº 105 de 10/01/2001 (Lei de Sigilo Bancário),
            autorizo a Instituição Financeira concedente do crédito, conforme aplicável, a revelar as Minhas Informações constantes ou que venham a
            constar do SCR a seu correspondente bancário BizCapital Correspondente Bancário Ltda., inscrito no CNPJ sob o nº 24.077.504/0001-78,
            e eventuais cessionários ou endossatários do crédito concedido.
        </p>
        <p>Estou ciente de que:</p>
        <p>
            a) o SCR tem por finalidades fornecer informações ao BCB para fins de supervisão e fiscalização do risco de crédito a que estão expostas
            as instituições financeiras e propiciar o intercâmbio de informações entre essas instituições com o
            objetivo de subsidiar decisões de crédito e de negócios;
        </p>
        <p>
            b) o SCR é alimentado mensalmente pelas instituições financeiras, mediante coleta de informações sobre operações
            concedidas com responsabilidade igual ou superior a R$ 200,00 (duzentos reais), vencidas e vincendas, inclusive em atraso e
            baixadas com prejuízo, bem como valores referentes às garantias, tais como fianças e avais, prestadas pelos clientes em favor
            das instituições financeiras;
        </p>
        <p>
            c) poderei ter acesso aos dados constantes em meu nome no SCR por meio do Registrato – Extrato de Registro de Informações no BCB, um sistema
            que fornece gratuitamente informações disponíveis em cadastros administrados pelo BCB; bem como, alternativamente,
            através das Centrais de Atendimento ao Público do BCB, pessoalmente, ou por correspondência,
            conforme orientações disponíveis em seu ambiente virtual
            (
            <a href="http://www.bcb.gov.br" target="_blank">
                www.bcb.gov.br
            </a>
            );
        </p>
        <p>
            d) as informações remetidas para fins de registro no SCR são de exclusiva responsabilidade da instituição financeira,
            inclusive no que tange às inclusões, correções, exclusões, registro de medidas judiciais e manifestações de discordância
            quanto às tais informações constantes no sistema, sendo certo que somente a instituição financeira responsável
            pela inclusão poderá alterá-la ou excluí-la;
        </p>
        <p>
            e) pedidos de correções, de exclusões e de manifestações de discordância quanto às informações constantes do SCR deverão ser
            dirigidas, por meio de requerimento escrito e fundamentado, primeiramente à instituição responsável pela remessa das informações.
            Em caso de não entendimento entre as partes, poderá ser registrada reclamação na Central de Atendimento ao Público do BCB, ou por
            meio de medida judicial cabível, em face da instituição financeira responsável pelo lançamento de tais informações;
        </p>
        <p>
            f) a consulta sobre qualquer informação ao SCR depende de minha
            prévia autorização;
        </p>
        <p>
            g) os extratos das informações constantes no SCR são elaborados com base no saldo existente no último dia do mês de referência,
            de acordo com critérios contábeis e metodologia específica estabelecidos pelo BCB, podendo diferenciar-se daqueles apresentados
            por outros sistemas que tenham natureza e finalidade distintas;
        </p>
        <p>
            h) mais informações sobre o SCR podem ser obtidas em consulta ao
            ambiente virtual do BCB (
            <a href="http://www.bcb.gov.br" target="_blank">
                www.bcb.gov.br
            </a>
            )
        </p>
    </div>
);

export default AuthorizeInformationAccessText;
